export class TaskRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "Task";
    const model = App.Models.Task;
    const collectionClass = App.Collections.Tasks;

    super(entityName, model, collectionClass);

    if (!Monet.Session.Task) {
      Monet.Session.Task = {};
      this.initializeNewTask();
    }
  }

  initializeNewTask = () => {
    Monet.Session.Task.newTask = new App.Models.Task();

    Monet.Session.Task.newTask.equipments = [];
    Monet.Session.Task.newTask.drivers = [];
    Monet.Session.Task.newTask.locations = [];
    Monet.Session.Task.newTask.anotherTask = [];
    Monet.Session.Task.newTask.routes = [];
    Monet.Session.Task.newTask.events = [];
    Monet.Session.Task.newTask.maps = [];
    Monet.Session.Task.newTask.orders = [];
  };

  initializeLastLinkForm = () => {
    Monet.Session.Task.lastLinkForm = {
      drivers: {
        ids: [],
        nodes: [],
        data: []
      },
      equipments: {
        ids: [],
        nodes: [],
        data: []
      },
      routes: {
        ids: [],
        nodes: [],
        data: []
      },
      locations: {
        ids: [],
        nodes: [],
        data: []
      },
      events: {
        ids: [],
        nodes: [],
        data: [],
        filter: []
      },
      anotherTask: {
        ids: [],
        nodes: [],
        data: []
      },
      maps: {
        ids: [],
        nodes: [],
        data: []
      },
      surveys: {
        ids: [],
        nodes: [],
        data: []
      },
      orders: {
        ids: [],
        nodes: [],
        data: []
      },
      agruped: {
        ids: [],
        nodes: [],
        data: [],
        models: []
      }
    };
  };

  beforePopulateLocalCollection = () => {
    this.projection =
      '{"filters":["*","userChangeTaskFormStatus.login", "organization.*", "organization.id", "organization.description", "comments.*", "comments.userCreated.*", "userCreated.*","userModified.*", "type.*" , "userAssigned.*", "groupAssigned.*", "taskStatus.*", "maps.*", "taskLinkeds.*", "taskLinkeds.route.*","taskLinkeds.route.organization.*", "taskLinkeds.equipment.*", "taskLinkeds.user.*", "taskLinkeds.location.*", "taskLinkeds.survey.*", "taskLinkeds.eventLog.*", "taskLinkeds.anotherTask.*","taskReason.id","taskReason.description", "taskResolution.id","taskResolution.description"]}';
  };

  getDriverFromMapEvent = (route, callback) => {
    if (route && route.id) {
      var url =
        'Route/restrictions?criteria={"filters":["id", "driverAssignments.*","driverAssignments.driver.id", "driverAssignments.driver.name"],"firstResult":0,"maxResults":51}';
      var criteria = {
        criteriaChain: [
          {
            and: [
              {
                eq: route.id,
                attr: "id"
              }
            ]
          }
        ]
      };

      var request = new Monet.Ajax();
      request.url = url;
      request.data = criteria;
      request.method = "post";

      request.success = function(data) {
        var drivers = [];

        if (data.length && data.driverAssignments) {
          data = data[0];

          for (var i = 0, l = data.driverAssignments.length; i < l; i++) {
            drivers.push(data.driverAssignments[i].driver);
          }
        }

        callback(drivers);
      };

      request.send();
    } else {
      callback([]);
    }
  };

  populateFormWithInfoFromEventLog = () => {
    var eventLog = Monet.Session.Task.eventLog;
    if (eventLog && !eventLog.entity) {
      this.getDriverFromMapEvent(eventLog.route, drivers => {
        Monet.Session.Task.newTask = { drivers: [], maps: [], anotherTask: [] };

        if (drivers && drivers.length) {
          for (var i = 0, l = drivers.length; i < l; i++) {
            Monet.Session.Task.newTask.drivers.push({
              driver: {
                id: drivers[i].id,
                key: drivers[i].name
              }
            });
          }
        }

        if (eventLog.equipment && eventLog.equipment.key) {
          Monet.Session.Task.newTask.equipments = [
            {
              equipment: {
                id: eventLog.equipment.id,
                key: eventLog.equipment.key
              }
            }
          ];
        } else {
          Monet.Session.Task.newTask.equipments = [];
        }

        if (eventLog.id) {
          Monet.Session.Task.newTask.events = [
            {
              eventLog: {
                id: eventLog.id,
                messageBody: eventLog.messageBody,
                timeValuedTrue: eventLog.timeValuedTrue
              }
            }
          ];
        } else {
          Monet.Session.Task.newTask.events = [];
        }

        if (eventLog.latitude && eventLog.longitude && eventLog.stop) {
          Monet.Session.Task.newTask.maps = [
            {
              id: null,
              key: eventLog.stop.location ? eventLog.stop.location.key : null,
              latitude: eventLog.latitude,
              longitude: eventLog.longitude,
              stopLatitude: eventLog.stop.latitude,
              stopLongitude: eventLog.stop.longitude,
              icon: eventLog.event.icon
            }
          ];
        } else if (eventLog.latitude && eventLog.longitude) {
          Monet.Session.Task.newTask.maps = [
            {
              id: null,
              key: null,
              latitude: eventLog.latitude,
              longitude: eventLog.longitude,
              icon: eventLog.event.icon
            }
          ];
        } else {
          Monet.Session.Task.newTask.maps = [];
        }

        if (eventLog.route && eventLog.route.key) {
          Monet.Session.Task.newTask.routes = [
            {
              route: {
                id: eventLog.route.id,
                key: eventLog.route.key,
                date: eventLog.route.date,
                organization: {
                  description: eventLog.route.organization.description
                }
              }
            }
          ];
        } else {
          Monet.Session.Task.newTask.routes = [];
        }

        Monet.Session.Task.lastLinkForm = {
          drivers: {
            ids: [],
            nodes: [],
            data: []
          },
          equipments: {
            ids: [],
            nodes: [],
            data: []
          },
          routes: {
            ids: [],
            nodes: [],
            data: []
          },
          locations: {
            ids: [],
            nodes: [],
            data: []
          },
          events: {
            ids: [],
            nodes: [],
            filter: [],
            data: [
              {
                id: eventLog.id,
                eventLog: {
                  id: eventLog.id,
                  timeValuedTrue: eventLog.timeValuedTrue,
                  timeValuedFalse: eventLog.timeValuedFalse,
                  closed: eventLog.closed,
                  messageBody: eventLog.messageBody
                }
              }
            ]
          },
          anotherTask: {
            ids: [],
            nodes: [],
            data: []
          },
          maps: {
            ids: [],
            nodes: [],
            data: []
          },
          surveys: {
            ids: [],
            nodes: [],
            data: []
          },
          orders: {
            ids: [],
            nodes: [],
            data: []
          }
        };

        if (Monet.Session.Task.newTask.equipments) {
          Greenmile.Task.RelatedInfo.Equipment.createFullEquipmentInfo(
            Monet.Session.Task.newTask.equipments,
            {
              state: "CREATE"
            }
          );
        }

        if (Monet.Session.Task.newTask.drivers) {
          Greenmile.Task.RelatedInfo.Driver.createFullDriverInfo(
            Monet.Session.Task.newTask.drivers,
            {
              state: "CREATE"
            }
          );
        }

        if (Monet.Session.Task.newTask.locations) {
          Greenmile.Task.RelatedInfo.Location.createFullLocationInfo(
            Monet.Session.Task.newTask.locations,
            {
              state: "CREATE"
            }
          );
        }

        if (Monet.Session.Task.newTask.surveys) {
          Greenmile.Task.RelatedInfo.Survey.createFullSurveyInfo(
            Monet.Session.Task.newTask.surveys,
            {
              state: "CREATE"
            }
          );
        }

        if (Monet.Session.Task.newTask.anotherTask) {
          Greenmile.Task.RelatedInfo.Task.createFullTaskInfo(
            Monet.Session.Task.newTask.anotherTask,
            {
              state: "CREATE"
            }
          );
        }

        if (Monet.Session.Task.newTask.routes) {
          Greenmile.Task.RelatedInfo.Route.createFullRouteInfo(
            Monet.Session.Task.newTask.routes,
            {
              state: "CREATE"
            }
          );
        }

        if (Monet.Session.Task.newTask.events) {
          Greenmile.Task.RelatedInfo.Event.createFullEventInfo(
            Monet.Session.Task.newTask.events,
            {
              state: "CREATE"
            }
          );
        }

        if (Monet.Session.Task.newTask.maps) {
          Greenmile.Task.RelatedInfo.Map.createFullMapsInfo(
            Monet.Session.Task.newTask.maps,
            {
              state: "CREATE"
            }
          );
        }

        if (Monet.Session.Task.lastLinkForm.events) {
          var data = Monet.Session.Task.lastLinkForm.events.data[0];

          if (data && data.eventLog && data.eventLog.messageBody) {
            this.editor.e.body.innerHTML = data.eventLog.messageBody;
          }
        }

        var fields = App.Forms.Task.form.fields;

        if (eventLog.route && eventLog.route.organization) {
          fields.organization.setValue(eventLog.route.organization);
        }

        if (eventLog.equipment && eventLog.equipment.organization) {
          fields.organization.setValue(eventLog.equipment.organization);
        }

        Greenmile.Task.RelatedInfo.updateRelatedInfoContent({
          state: "CREATE"
        });
      });
    } else {
      this.initializeNewTask();
    }

    Monet.Session.Task.eventLog = null;
  };

  beforePopulateForm = (model) => {
    this.initializeNewTask();
    this.initializeLastLinkForm();

    var divContainer = document.getElementById("taskLinkInfoContainer");
    var createdAt = document.createElement("input");
    var userCreated = document.createElement("input");
    var userModified = document.createElement("input");
    var form = document.querySelector("#Task .MonetUIForm");
    var taskIsReadOnly = document.createElement("input");
    var statusHidden = document.createElement("input");
    var modified = document.createElement("input");

    taskIsReadOnly.type = "hidden";
    taskIsReadOnly.id = "isReadOnly";
    taskIsReadOnly.name = "isReadOnly";
    taskIsReadOnly.className = "modelAttribute";

    statusHidden.type = "hidden";
    statusHidden.id = "taskStatus.id";
    statusHidden.name = "taskStatus.id";
    statusHidden.className = "modelAttribute";

    modified.type = "hidden";
    modified.id = "modified";
    modified.name = "modified";
    modified.className = "modelAttribute";

    createdAt.type = "hidden";
    createdAt.id = "created";
    createdAt.name = "created";
    createdAt.className = "modelAttribute";

    userCreated.type = "hidden";
    userCreated.id = "userCreated_id";
    userCreated.name = "userCreated.id";
    userCreated.className = "modelAttribute";

    userModified.type = "hidden";
    userModified.id = "userModified_id";
    userModified.name = "userModified.id";
    userModified.className = "modelAttribute";

    form.appendChild(createdAt);
    form.appendChild(userCreated);
    form.appendChild(userModified);
    form.appendChild(taskIsReadOnly);
    form.appendChild(statusHidden);
    form.appendChild(modified);

    divContainer.id = "taskLinkInfoContainer";
    const image = require("static/images/general/loading_blue.svg");
    divContainer.innerHTML = '<img src="' + image;

    this.checkIfsuggested(model);
    this.setupTaskResolutionLookupField(model);
  };

  setupTaskResolutionLookupField = (model) => {
    const fields = App.Forms.Task?.form?.fields;
    fields && fields.taskResolution.inputContainer.remove();
    const taskResolutionValue = document.createElement('div');
    taskResolutionValue.className = "Task_taskResolution___value";
    const taskResolution = model?.attributes?.taskResolution;

    taskResolutionValue.innerHTML = taskResolution ? Monet.I18n.getResourcesByKey(taskResolution.description) : '-';
    fields.taskResolution.lookupContainer.appendChild(taskResolutionValue);
  };

  checkIfsuggested = (model) => {
    const modelAttributes = model.attributes;
    const taskLinkedLocations =  modelAttributes.taskLinkeds.filter(item =>  item.location);
    const taskFormType = modelAttributes.taskFormType;

    const suggestedData =  modelAttributes.jsonData && JSON.parse(modelAttributes.jsonData);
    const locationSuggested = suggestedData && suggestedData.location;
    const validateLocation = locationSuggested && taskLinkedLocations.filter( taskLinked => taskLinked.location.id === locationSuggested.id);

    if(taskFormType && taskLinkedLocations.length && (validateLocation && validateLocation.length)) {
      switch (taskFormType) {
        case 'GEOCODE':
          new Greenmile.Task.SuggestedGeocoding(modelAttributes, suggestedData, validateLocation[0].location)
            .render();
          break;
        case 'TIME_WINDOW':
          new Greenmile.Task.SuggestedServiceWindow(modelAttributes, suggestedData, validateLocation[0].location)
            .render();
          break;
      }
    }
  };

  afterCreateForm = (entity, formData, crudStage) => {
    var titleField = document.querySelector('#Task input[name="title"]');

    if (titleField) {
      titleField.style.width = "calc(100% - 210px)";
    }

    Greenmile.Task.RelatedInfo.createLinkInfoContainers(crudStage);
    Greenmile.Task.Comments.render();

    this.initializeRichTextField();
    this.initializeLastLinkForm();
    if (crudStage === "new") {
      this.populateFormWithInfoFromEventLog();
    } else if (crudStage === "edit") {
      this.renameCancelBtnOnEdit()
    }

    this.addListenerInTaskTypeField();
    this.checkAssignmentsRules();
  };

  addListenerInTaskTypeField = () => {
    const fields = App.Forms.Task?.form?.fields;
    if(fields) {
      const taskTypeField = fields.type;
      taskTypeField.setOnBlur(() => {
        const taskReasonField = fields.taskReason;
        const standardTaskReason = taskTypeField.value?.model?.standardTaskReason;
        if(standardTaskReason) {
          taskReasonField.setValue(standardTaskReason);
        } else {
          taskReasonField.clear();
        }
      });
    }
  };

  initializeRichTextField = () => {
    this.editor = new TINY.editor.edit("editor", {
      id: '#Task_description textarea[name="description"]',
      width: "auto",
      height: 175,
      cssclass: "tinyeditor",
      controlclass: "tinyeditor-control",
      rowclass: "tinyeditor-header",
      dividerclass: "tinyeditor-divider",
      controls: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "subscript",
        "superscript",
        "|",
        "orderedlist",
        "unorderedlist",
        "|",
        "outdent",
        "indent",
        "|",
        "leftalign",
        "centeralign",
        "rightalign",
        "blockjustify",
        "|",
        "unformat",
        "|",
        "undo",
        "redo",
        "n",
        "font",
        "size",
        "style",
        "|",
        "image",
        "hr",
        "link",
        "unlink",
        "|",
        "print"
      ],
      footer: true,
      fonts: ["Verdana", "Arial", "Georgia", "Trebuchet MS"],
      xhtml: true,
      bodyid: "tinyeditorDescription",
      footerclass: "tinyeditor-footer",
      content_css: "resources/stylesheets/tinyeditor-overwrite.css",
      toggle: { text: "source", activetext: "wysiwyg", cssclass: "toggle" },
      resize: { cssclass: "resize" }
    });

    var fontEl = document.querySelector(".tinyeditor-font"),
      sizeEl = document.querySelector(".tinyeditor-size"),
      styleEl = document.querySelector(".tinyeditor-style");

    fontEl.tabIndex = -1;
    sizeEl.tabIndex = -1;
    styleEl.tabIndex = -1;

    var tinyEditDocumentBody = document.querySelector("#Task iframe");

    if (tinyEditDocumentBody.contentWindow.document.body) {
      tinyEditDocumentBody.contentWindow.document.body.style.fontFamily =
        "Arial";
      tinyEditDocumentBody.contentWindow.document.body.style.fontSize = "12px";
    }
  };

  afterPopulateForm = model => {
    if (this.editor && model && this.editor.e.body) {
      this.editor.e.body.innerHTML = (model.get("description") || "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">");
    }
    this.getFullInfoFromEditModel(model);
    this.setupSectionsMultiFiles(model);
    this.disableOrganizationField();

    const taskResolutionComment = model.get("taskResolutionComment");

    if (taskResolutionComment) {
      const field = new Monet.UI.Fields.TextArea();

      field.setTextLabel(Monet.I18n.getResourcesByKey('taskmanager.task.resolutioncomment'));
      field.setValue(taskResolutionComment);
      field.disable();
      field.render();
      field.input.style.width = "210px";
      
      const form = App.Forms[this.entityName].form;
      
      form.setField('taskResolutionComment', field);
      
      const taskResolutionField = form.getField("taskResolution");
  
      taskResolutionField.rootEl.insertAdjacentElement('afterend', field.rootEl);
    }
  };

  disableOrganizationField = () => {
    const fields = App.Forms.Task?.form?.fields;
    fields?.organization && fields.organization.disable();
  };

  setupSectionsMultiFiles = (model) => {
    [
      {fieldName: 'attachments', url: 'AttachedPhotos'},
      {fieldName: 'multipleAttachments', url: 'AttachedFiles'}
    ].forEach( dataField => {

      this.getSectionFiles(model, dataField);

    });
  };

  getSectionFiles = (model, dataField) => {
    const form = App.Forms.Task.form;
    const field = form?.fields[dataField.fieldName];

    if(field) {
      field.triggerLoading();

      const ajax = new Monet.Ajax();
      ajax.url = `TaskAttachments/${dataField.url}/${model.attributes.id}`;
      ajax.method = 'get';
      ajax.success = (data) => {
        field.triggerLoading();
        if (data) {
              field.setValue(data);
          }
      };
      ajax.error = () => {
          field.triggerLoading();
          field.renderErrorMessages([Monet.Form.Messages.mountErrorMessageObject('uploadField.getImageError')]);
      };
      ajax.send();
    }
  };

  getRelatedInfo = (data, now) => {
    data.maps = Monet.Session.Task.lastLinkForm.maps.data.map((data) => {

      if(!data.when) {
        data.when = now;
        delete data.id;
      }

      return data;
    });

    data.taskLinkeds = Object.entries(Monet.Session.Task.lastLinkForm).reduce((previous, [currKey, currValue]) => {
      if (currKey !== 'maps' && currValue.data.length) {
        currValue.data.forEach(data => {
          data.when = data.when || now;
          previous.push(data);
        });
      }
      return previous;
    }, []);

    return data;
  };

  updateTaskStatusData = (data) => {
    if(this.taskStatusUpdated) {
      data.taskStatus = this.taskStatusUpdated;
    }
    return data;
  }

  beforeCreate = data => {
    if (this.editor.t.style.display === 'block') {
      data.attributes.description = this.editor.t.value;
    } else {
      data.attributes.description = this.editor.e.body.innerHTML;
    }

    const now = Monet.Format.DateTime.formatToISOString(new Date());
    data.attributes.created = now;
    data.attributes.modified = now;
    data.attributes.isReadOnly = false;
    data.attributes = this.getRelatedInfo(data.attributes, now);
  };

  beforeUpdate = data => {
    if (this.editor.t.style.display === 'block') {
      this.form_edit.description = this.editor.t.value;
    } else {
      this.form_edit.description = this.editor.e.body.innerHTML;
    }

    const now = Monet.Format.DateTime.formatToISOString(new Date());
    data.modified = now;
    data = this.getRelatedInfo(data, now);
    data = this.updateTaskStatusData(data);
  };

  afterCreate = model => {
    this.checkMultipleFilesToPersist(model);
  };

  checkMultipleFilesToPersist = model => {
    const form = App.Forms.Task.form;
    const taskId = model?.attributes?.id;
    const imagesToSave = this.getImagesToPersist(form);
    const filesToSave = this.getFilesToPersist(form);
    const allAttachments = [...imagesToSave, ...filesToSave];

    if(allAttachments?.length && taskId) {
      const formData = this.prepareFormData(allAttachments, taskId);
      this.persistMultiFiles(form, formData);

    } else {
      window.location = "#/" + this.entityName;
    }
  };

  getImagesToPersist = (form) => {
    const multiplePhotosField = form?.fields?.attachments;
    return multiplePhotosField?.getImagesToSave();
  };

  getFilesToPersist = (form) => {
    const multipleAttachmentsField = form?.fields?.multipleAttachments;
    return multipleAttachmentsField?.getImagesToSave();
  };

  prepareFormData = (allAttachments, taskId) => {
    const formData = new FormData();
    const task = {
        id: taskId
    };

    const getFileNameToPersist = (attachment, taskId) => {
      const fileName = attachment.fileName;
      const fileExtension = fileName.split('.').pop();

      if(fileExtension === 'jpg' || fileExtension === 'jpeg') {
        return `task_photo_${taskId}_${new Date().getTime()}.${fileExtension}`

      } else {

        const fileNameWithExtension = fileName.replace(fileExtension, '');

        const removeSpecials = (str) => {
            const lower = str.toLowerCase();
            const upper = str.toUpperCase();

            let res = "";
            for(let i = 0; i < lower.length; ++i) {
                if(lower[i] != upper[i] || lower[i].trim() === '' || !isNaN(lower[i]))
                    res += str[i];
            }
            return res;
        };

        const slugify = (str) => {
          const map = {
              '-' : ' ',
              '-' : '_',
              'a' : 'á|à|ã|â|À|Á|Ã|Â',
              'e' : 'é|è|ê|É|È|Ê',
              'i' : 'í|ì|î|Í|Ì|Î',
              'o' : 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
              'u' : 'ú|ù|û|ü|Ú|Ù|Û|Ü',
              'c' : 'ç|Ç',
              'n' : 'ñ|Ñ'
          };

          for (const pattern in map) {
              str = str.replace(new RegExp(map[pattern], 'g'), pattern);
          };

          return str;
        };

        const fileNameWithOutSpecials = removeSpecials(fileNameWithExtension);
        const fileNameWithOutAccents = slugify(fileNameWithOutSpecials);
        const fileNameWithOutSpaces = fileNameWithOutAccents.replace(/ /g,"_");

        return `${fileNameWithOutSpaces}.${fileExtension}`
      }

    };

    formData.append('task',new Blob([JSON.stringify(task)], { type: "application/json" }));
    allAttachments.forEach(attachment => {
      const fileNameToPersist = getFileNameToPersist(attachment, taskId);

      formData.append(
        'files',
        new Blob([attachment.data]),
        fileNameToPersist
      );
    });

    return formData;
  };

  persistMultiFiles = (form, formData) => {
    form.triggerLoadingBtns();

    const _setErrorStyleToFilesContainer = () => {
      const multipleAttachmentsField = form?.fields?.multipleAttachments;
      const imageContainerEl = multipleAttachmentsField?.imageContainer;
      if(imageContainerEl) {
        imageContainerEl.className += " error";
      }
    };

    const ajax = new Monet.Ajax({ contentType: 'multipart/form-data' });
    ajax.url = `TaskAttachments/WithTask/Batch`;
    ajax.method = 'post';
    ajax.data = formData;
    ajax.success = () => {
      form.triggerLoadingBtns();
      window.location = "#/" + this.entityName;
    };
    ajax.error = (error) => {
      form.triggerLoadingBtns();
      _setErrorStyleToFilesContainer();

      const monetMessage = new Monet.Form.Messages.InlineMessage();
      const errorResponse = error?.response && JSON.parse(error.response);
      const errorMessages = errorResponse?.errorMessages  || [Monet.Form.Messages.mountErrorMessageObject('uploadMultiFileField.uploadError.standard')];
      monetMessage.setScope(`#${this.entityName} #form_and_grid`);
      monetMessage.setInfoType("error");
      monetMessage.setMessage({ errorMessages });
      monetMessage.triggerMessage();
    };
    ajax.send();
  };

  deleteImage = (imageId, callbackSuccess) => {
    const form = App.Forms.Task.form;
    const multiplePhotosField = form?.fields?.attachments;
    const ajax = new Monet.Ajax();
    ajax.url = `/TaskAttachments/${imageId}`;
    ajax.method = 'delete';
    ajax.success = () => {
      form.triggerLoadingBtns();
      callbackSuccess();
    };
    ajax.error = () => {
      form.triggerLoadingBtns();
      multiplePhotosField.renderErrorMessages([Monet.Form.Messages.mountErrorMessageObject('uploadField.uploadImageError')]);
    };
    form.triggerLoadingBtns();
    ajax.send();
  }

  downloadFile = (fileId) => {
      const url = `./TaskAttachments/AttachedFiles/Download/${fileId}`;
      window.location.href = url;
  }

  updateTaskStatus = model => {
    var statusHidden = document.getElementById("taskStatus.id");
    statusHidden.value = model.taskStatus.id;
  };

  appendTaskFlowControl = task => {
    var request = new Monet.Ajax();

    request.url = "Task/" + task.id + "/nextStatus";
    request.data = '{"id": ' + task.taskStatus.id + "}";
    request.method = "post";

    request.success = (function(scope) {
      return function(flowArray) {
        scope.iterateWorkFlowButtons(task, flowArray);
        App.Views.Task.verifyTaskStatusAndToogleForm(flowArray);
      };
    })(this);

    request.send();
  };

  iterateWorkFlowButtons = (task, workflowArray) => {
    var workflowButton,
      workflowButtons = [],
      workflowObject;

    for (var i = 0; i < workflowArray.length; i++) {
      workflowObject = workflowArray[i];
      workflowButton = this.createWorkflowButton(workflowObject);
      this.addListenerToWorkflowButton(task, workflowButton);

      workflowButtons.push(workflowButton);
      this.appendWorkflowButtons(workflowButtons);
    }
  };

  appendWorkflowButtons = workflowButtons => {
    var workflowCanvas = document.querySelector(
        "#Task .MonetUIFormSection .buttonsUp"
      ),
      buttonElements = workflowCanvas.querySelectorAll(".workflow"),
      buttonParent,
      i,
      j;

    if (workflowCanvas) {
      for (j = 0; j < buttonElements.length; j++) {
        buttonParent = buttonElements[j].parentNode;
        buttonParent.removeChild(buttonElements[j]);
      }

      for (i = 0; i < workflowButtons.length; i++) {
        workflowCanvas.appendChild(workflowButtons[i]);
      }
    }
  };

  createWorkflowButton = flowObject => {
    var workflowButton = document.createElement("input");
    workflowButton.type = "button";
    workflowButton.value = Monet.I18n.getResourcesByKey(flowObject.description);
    workflowButton.className = "btn i18nResource workflow";
    workflowButton.setAttribute(
      "status_id",
      flowObject.nextWorkflowStatus.taskStatus.id
    );
    workflowButton.setAttribute(
      "status_description",
      flowObject.nextWorkflowStatus.taskStatus.description
    );

    return workflowButton;
  };

  addListenerToWorkflowButton = (task, workflowButton) => {
    var clickEvent = (function(scope) {
      return function(event) {
        scope.disableWorkflowButtons();
        scope.changeTaskWorkflowStatus(task, event.target);
      };
    })(this);

    workflowButton.removeEventListener("click", clickEvent);
    workflowButton.addEventListener("click", clickEvent);
  };

  disableWorkflowButtons = () => {
    this.toggleWorkflowButton(true);
  };

  enableWorkflowButtons = () => {
    this.toggleWorkflowButton(false);
  };

  toggleWorkflowButton = state => {
    var workflowCanvas = document.querySelector(
        "#Task .MonetUIFormSection .buttonsUp"
      ),
      buttonElements = workflowCanvas.querySelectorAll(".workflow"),
      i;

    for (i = 0; i < buttonElements.length; i++) {
      buttonElements[i].disabled = state;
    }
  };

  changeTaskWorkflowStatus = (task, button) => {
    const status = button.attributes['status_description'];
    if(status && status.value.includes('close')) {
      new Greenmile.Task.AssignResolution(this, () => this.sendChangeStatus(task, button))
        .showModal();
    } else {
      this.sendChangeStatus(task, button);
    }
  };

  changeHiddenAndHeaderStatus = (task, button) => {
    var statusHidden = document.getElementById("taskStatus.id");
    var statusHeader = document.getElementById("task.header.status");

    statusHeader.innerHTML = Monet.I18n.getResourcesByKey(
      button.getAttribute("status_description")
    );
    statusHidden.value = button.getAttribute("status_id");
  };

  changeModifiedDateHeader = () => {
    const modifiedDateHeader = document.getElementById("task.header.modifiedAt");
    modifiedDateHeader.innerHTML = Monet.Format.DateTime.getFormattedLocaleToday();
  };

  sendChangeStatus = (task, button) => {
    var request = new Monet.Ajax();

    request.url = "Task/" + task.id + "/updateStatus";
    request.data = '{"id": ' + button.getAttribute("status_id") + "}";
    request.method = "post";

    request.success = (function(scope) {
      return function(flowArray) {
        scope.changeHiddenAndHeaderStatus(task, button);
        scope.changeModifiedDateHeader();
        scope.iterateWorkFlowButtons(task, flowArray);
        scope.enableWorkflowButtons();
        App.Views.Task.verifyTaskStatusAndToogleForm(flowArray);
        scope.taskStatusUpdated = flowArray[0].previousWorkflowStatus.taskStatus;
      };
    })(this);

    request.error = (function(scope) {
      return function() {
        scope.enableWorkflowButtons();
      };
    })(this);

    request.send();
  };

  getFullInfoFromEditModel = model => {
    var inputCreatedAt = document.getElementById("created");
    var userCreated = document.getElementById("userCreated_id");
    var userModified = document.getElementById("userModified_id");
    var taskIsReadOnly = document.getElementById("isReadOnly");
    if (model) {
      var url =
        'Task/restrictions?criteria={"filters":["*", "userChangeTaskFormStatus.login", "comments.*", "comments.userCreated.*", "userCreated.*","userModified.*", "type.*" , "userAssigned.*", "groupAssigned.*", "taskStatus.*", "maps.*", "taskLinkeds.*", "taskLinkeds.route.*","taskLinkeds.route.organization.*", "taskLinkeds.equipment.*", "taskLinkeds.user.*", "taskLinkeds.location.*", "taskLinkeds.survey.*", "taskLinkeds.eventLog.*", "taskLinkeds.anotherTask.*", "taskLinkeds.order.*", "taskReason.id","taskReason.description", "taskResolution.id","taskResolution.description"]}';
      const filter = `{ "attr": "id", "eq" : ${model.get("id")} }`;

      var request = new Monet.Ajax();
      request.url = url;
      request.data = filter;
      request.method = "post";

      request.success = (function(scope) {
        return function(data) {

          inputCreatedAt.value = data[0].created;
          userCreated.value = data[0]?.userCreated?.id;
          userModified.value = data[0]?.userModified?.id;
          taskIsReadOnly.value = data[0]?.isReadOnly;

          App.Views.Task.appendTaskAdditionalInformation(data[0]);

          Greenmile.Task.RelatedInfo.createTaskInformation(data);
          Greenmile.Task.RelatedInfo.updateRelatedInfoContent({
            state: "UPDATE"
          });

          scope.appendTaskFlowControl(data[0]);
          scope.updateTaskStatus(data[0]);
        };
      })(this);

      request.send();
    }
  };

  onValidate = () => {
    var form = App.Forms.Task.form;
    var error = form.validate();
    var dueDate = form.fields.dueDate.getValue();
    var now = new Date().getTime();

    if (dueDate) {
      const parsedDate = Monet.Format.DateTime.parse(dueDate);
      if (parsedDate.getTime() < now) {
        form.fields.dueDate.setValue(now);
      }
    }

    this.allow_submit = error;

    if (this.allow_submit.status && this.crudStage === 'edit') {
      const { created, userCreated, userModified, isReadOnly, taskStatus } = this.updateModel.attributes;
      this.form_edit = { ...this.form_edit, created, userCreated, userModified, isReadOnly, taskStatus };
    }
  };

  renameCancelBtnOnEdit = () => {
    const cancelBtn = document.querySelector('#Task #Task_btn_cancel')
    if(cancelBtn) {
      cancelBtn.value =  Monet.I18n.getResourcesByKey('Task.button.exit');
    }
  };

  checkAssignmentsRules = () => {
    try {
      const fields = App.Forms[this.entityName]?.form?.fields;
      const assignmentsFields = ['userAssigned', 'groupAssigned'];

      const handleDisable = (field) => {
        if (field === assignmentsFields[0]) {
          fields[assignmentsFields[1]].disable();
        } else {
          fields[assignmentsFields[0]].disable();
          fields['taskAssignToMe'].hide();
        }
      };

      const handleEnable = (field) => {
        if (field === assignmentsFields[0]) {
          fields[assignmentsFields[1]].enable();
        } else {
          fields[assignmentsFields[0]].enable();
          fields['taskAssignToMe'].show();
        }
      };

      const enableDisableLookupFields = (field) => {
        const value = fields[field].getValue();

        if (value !== '') {
          handleDisable(field);
        } else {
          handleEnable(field);
        }
      };

      if (fields) {
        assignmentsFields.forEach(field => {
          enableDisableLookupFields(field);

          fields[field].setOnBlur(() => {
            enableDisableLookupFields(field);
          });
        });
      }
    } catch (error) {
      new Monet.Exception.ReturnError(
        this,
        "Trying access userAssigned or groupAssigned fields."
      ).console();
    };
  };
  beforeList = (isUpdate = false) => {
    if (!isUpdate) {
      App.Forms.Task.table?.getColumns().forEach((column) => {
        if (column.field === 'description') {
          column.sortable = false;
        }
      });
    }
  }
}

App.Routers.Task = TaskRouter;
